import Vue from 'vue'

export const mainDialogState = Vue.observable({
  show: false,
  title: '',
  message: '',
  options: {},
  mode: 'ok',
  resolve: null,
})

function openDialog(message, options = {}, mode = 'ok') {
  return new Promise((resolve) => {
    mainDialogState.show = true
    mainDialogState.title = options.title || ''
    mainDialogState.message = message
    mainDialogState.options = options
    mainDialogState.mode = mode
    mainDialogState.resolve = resolve
  })
}

function closeDialog(result) {
  const resolve = mainDialogState.resolve

  mainDialogState.show = false
  mainDialogState.title = ''
  mainDialogState.message = ''
  mainDialogState.options = {}
  mainDialogState.mode = 'ok'
  mainDialogState.resolve = null

  if (resolve) {
    resolve(result)
  }
}

const mainDialogService = {
  msgBoxOk(message, options = {}) {
    return openDialog(message, options, 'ok')
  },

  msgBoxConfirm(message, options = {}) {
    return openDialog(message, options, 'confirm')
  },

  show(id) {
    if (window.vm && window.vm.$root) {
      window.vm.$root.$emit('main-dialog::show', id)
      window.vm.$root.$emit('bv::show::modal', id)
    }
  },

  hide(id) {
    if (mainDialogState.show && mainDialogState.options && mainDialogState.options.id === id) {
      closeDialog(false)
    }

    if (window.vm && window.vm.$root) {
      window.vm.$root.$emit('main-dialog::hide', id)
      window.vm.$root.$emit('bv::hide::modal', id)
    }
  },

  ok() {
    closeDialog(true)
  },

  cancel() {
    closeDialog(false)
  },
}

export default {
  install(Vue) {
    Vue.prototype.$mainDialog = mainDialogService
  }
}
